export default {
  agentRelationModal: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000291","根据商品分组选择客户") /* "根据商品分组选择客户" */,
  more: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000292","更多") /* "更多" */,
  saveNotNullTip: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000293","商品分组、客户级别 不能为空！") /* "商品分组、客户级别 不能为空！" */,
  saveTip: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000294","请点击保存按钮，保存相关信息！") /* "请点击保存按钮，保存相关信息！" */
};
